<template>
	<div class="home" v-if="showMsg">
		<div class="con">
			<p class="con_tit"><span></span><strong>提醒消息</strong></p>
			<div class="con_top">
				<!--对数据请求的处理，最为重要的一句话-->
				<ul :data="allTableData.slice((paginations.page_index-1)*paginations.page_size,paginations.page_index*paginations.page_size)">
					<li v-for='(item,index) in tableData'>
						<p>{{item.desc}}</p><span>{{item.created_at}}</span></li>
				</ul>
				<el-pagination style="width: 45%;height: 35px;border:none;padding: 0;margin: 0 auto;" @size-change="handleSizeChange" @current-change='current' :page-size="paginations.page_size" :current-page="paginations.page_index" :layout="paginations.layout" :total="paginations.total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import Qs from 'qs'
	export default {
		data() {
			return {
				tableData: [], //数据
				paginations: {
					page_index: 1, //当前页
					total: 0, //总数
					page_size: 5, //一页显示多少
					layout: 'prev, pager, next'
				},
				allTableData: [], //    每页的数据	
			};
		},
		props: {
			showMsg: {
				type:Boolean
			}
		},
		created() {
					
		},
		updated(){
			
		},
		mounted() {
			this.getInfoList();
		},
		methods: {
			getInfoList() {
				//会员活动数据
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				};
				var data1={
					'access-token':token
				};
				this.$axios({
					method: 'post',
					url: 'newsmessage/indexdatas',
					data: Qs.stringify(data1)
				}).then(response => {
					if(response.data.state==1){
						this.allTableData = response.data.ShowData;
						this.setPaginations();
					}					
				})
			},
			setPaginations() {
				this.paginations.total = this.allTableData.length; //数据的数量
				console.log(this.allTableData.length);
				this.paginations.page_index = 1; //默认显示第一页
				this.paginations.page_size = 5; //每页显示多少数据
				//显示数据
				this.tableData = this.allTableData.filter((item, index) => {
					return index < this.paginations.page_size;
				})
			},
			handleSizeChange(page_size) {
				console.log(page_size);
				this.paginations.page_index = 1; //第一页
				this.paginations.page_size = page_size; //每页先显示多少数据
				this.tableData = this.allTableData.filter((item, index) => {
					return index < page_size
				})
			},
			current(page) {
				// 跳转页数
				//获取当前页
				let index = this.paginations.page_size * (page - 1);
				//获取总数
				let allData = this.paginations.page_size * page;

				let tablist = [];
				for(let i = index; i < allData; i++) {
					if(this.allTableData[i]) {
						tablist.push(this.allTableData[i])
					}
					this.tableData = tablist
				}
			},
		}
	}
</script>
<style scoped>
	.home {
		padding: 0 18px 18px;
		box-sizing: border-box;
		width: 100%;
		height: auto;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #404040;
		text-align: left;
	}
	
	.con {
		width: 952px;
		height: auto;
		position: relative;
		overflow: hidden;
	}
	
	.con_tit {
		color: #005EB3;
		font-size: 18px;
		line-height: 45px;
		font-weight: bold;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.con_tit span{
		width:4px;
		height:16px;
		background:#4799E4;
		margin-right: 7px;
	}
	
	.con_top {
		width: 100%;
		height: 580px;
	}
	
	.con_top ul {
		width: 100%;
		height: 500px;
		margin-bottom: 20px;
	}
	
	.con_top ul li {
		height: 100px;
		border-bottom: 1px solid rgba(207, 212, 214, 1);
		box-sizing: border-box;
		padding: 29px 0 0 20px;
	}
	
	.con_top li p {
		color: #595959;
		line-height: 40px;
	}
	
	.con_top li span {
		color: #CFD4D6;
	}
</style>


// WEBPACK FOOTER //
// src/components/Msg.vue